import { UniqueIdentifier } from '@dnd-kit/core';
import { v5 as uuidv5 } from 'uuid';
import { SentenceDragAndDropData } from '../../../../types/quiz';

/**
 * Set answers and questions with id's.
 */
export const setData = (
  answers: SentenceDragAndDropData['answers'],
  distractors: SentenceDragAndDropData['distractors'],
) => {
  const answersWithId = answers.map((answer) => ({
    ...answer,
    id: uuidv5(answer.value, uuidv5.URL),
    parentId: uuidv5(answer.value, uuidv5.URL) + '_parent',
  }));

  const questions = [
    ...answersWithId.filter((u) => u.type === 'answer'),
    ...distractors.map((i) => ({
      value: i,
      id: uuidv5(i, uuidv5.URL),
    })),
  ];

  const initialState = answersWithId.reduce((sum, answer) => {
    if (answer.type === 'answer') {
      return { ...sum, [answer.parentId]: null };
    }
    return sum;
  }, {});

  return { answers: answersWithId, questions, initialState };
};

/**
 * IsCorrectAnswer.
 */
export const isCorrectAnswer = (fields: {
  [key: string]: UniqueIdentifier | null;
}) => {
  return Object.entries(fields).every(
    ([parent, child]) => parent.replace('_parent', '') === child,
  );
};
